import React, {Component} from 'react';
import {MultiImageDisplayProperties} from '../../content/displayproperties/MultiImageDisplayProperties';
import {Stack} from '@mui/material';

export default class MultiImageCell extends Component<MultiImageDisplayProperties> {
    override render() {
        return <Stack direction={"row"} justifyContent={"space-evenly"}>
            <img className={`image-container--multi`}
                 src={this.props.url1}
                 alt=""
                 title={this.props.description1}
            />
            <img className={`image-container--multi`}
                 src={this.props.url2}
                 alt=""
                 title={this.props.description2}
            />
        </Stack>;
    }
}
